import React from 'react';
import './PageSkeleton.css';

const PageSkeleton: React.FC = () => {
  return (
    <div className="page-skeleton">
      <div className="skeleton-header" />
      <div className="skeleton-content">
        <div className="skeleton-box skeleton-title" />
        <div className="skeleton-box skeleton-text" />
        <div className="skeleton-box skeleton-text skeleton-text--short" />
      </div>
    </div>
  );
};

export default PageSkeleton;
